'use client'

import { useState, useEffect } from 'react'

/**
 * Hook to detect if the current device is mobile
 * Uses viewport width as the primary signal with Tailwind's 'sm' breakpoint (640px)
 *
 * @param breakpoint - Maximum width to consider mobile (default: 640px)
 * @returns boolean indicating if device is mobile
 *
 * Note: Returns false on server-side to prevent hydration mismatch.
 * The actual mobile detection happens on first client render.
 */
export function useIsMobile(breakpoint = 640): boolean {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }

    // Check immediately on mount
    checkMobile()

    // Listen for resize events
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [breakpoint])

  return isMobile
}
